/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductionSetObjectType {
    BatesNumbered = 0,
    ExhibitBased = 1
}

export function ProductionSetObjectTypeFromJSON(json: any): ProductionSetObjectType {
    return ProductionSetObjectTypeFromJSONTyped(json, false);
}

export function ProductionSetObjectTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionSetObjectType {
    return json as ProductionSetObjectType;
}

export function ProductionSetObjectTypeToJSON(value?: ProductionSetObjectType | null): any {
    return value as any;
}

